<template>
  <div class="collection-container">
    <a-tabs v-model:activeKey="activeTabKey">
      <template #tabBarExtraContent>
        <div style="display: flex;align-items: center;">
          <p
            style="margin-right: 10px;"
            v-if="
              statusOptionList.find(item => item.value == baseInfo.status)
                ?.label
            "
          >
            实验状态：{{
              statusOptionList.find(item => item.value == baseInfo.status)
                ?.label
            }}
          </p>
          <a-button @click="cancel">返回</a-button>
        </div>
      </template>
      <a-tab-pane
        forceRender
        :disabled="isReport === '1'"
        key="1"
        tab="实验详情"
      >
        <div class="collection-container-tab">
          <a-form>
            <a-collapse
              v-model:activeKey="activeKey"
              :bordered="false"
              ghost
              forceRender
            >
              <a-collapse-panel key="1" header="基本信息" forceRender>
                <a-form-item label="实验类型">
                  {{
                    baseInfo.type == 0
                      ? '编程实验'
                      : baseInfo.type == 1
                      ? '多链接实验'
                      : 'collection实验'
                  }}
                </a-form-item>
                <a-form-item label="实验名称" required>
                  <a-input
                    :disabled="
                      isView ||
                        ([RUNNING, PAUSED, PUBLISED, END].indexOf(
                          disableStatus
                        ) >= 0 &&
                          !!baseInfo.id)
                    "
                    :maxlength="100"
                    placeholder="请输入"
                    style="width: 300px;"
                    v-model:value="baseInfo.name"
                  />
                </a-form-item>
                <a-form-item
                  label="实验collectionId"
                  required
                  v-if="baseInfo.type == 2"
                >
                  <!-- <a-select
                    v-model:value="baseInfo.collectionIds"
                    placeholder="查选选择collectionId"
                    mode="multiple"
                    style="width: 100%"
                    :filter-option="false"
                    :not-found-content="fetching ? undefined : null"
                    :options="collectionIdDatas"
                    @search="fetchUser"
                  >
                    <template v-if="fetching" #notFoundContent>
                      <a-spin size="small" />
                    </template>
                  </a-select> -->
                  <a-button
                    type="primary"
                    :disabled="
                      isView ||
                        ([RUNNING, PAUSED, PUBLISED, END].indexOf(
                          disableStatus
                        ) >= 0 &&
                          !!baseInfo.id)
                    "
                    @click="showCollectionList('edit')"
                    class="mr10"
                    >选择CollectionId</a-button
                  >
                  <a-button type="" @click="showCollectionList('view')"
                    >已选择的CollectionId</a-button
                  >
                  <CollectionList
                    :uniqueId="uniqueId"
                    v-model:show="collectionShow"
                    :type="collectionType"
                    :collectionIds="baseInfo.collectionIds"
                    @updateCollectionIds="updateCollectionIds"
                  ></CollectionList>
                </a-form-item>
                <a-form-item
                  label="实验地址"
                  required
                  v-if="baseInfo.type == 1"
                >
                  <a-input
                    :disabled="
                      isView ||
                        ([RUNNING, PAUSED, PUBLISED, END].indexOf(
                          disableStatus
                        ) >= 0 &&
                          !!baseInfo.id)
                    "
                    placeholder="请输入"
                    style="width: 300px;"
                    class="mr10"
                    :maxlength="300"
                    v-model:value="baseInfo.url"
                  />
                  <a-checkbox
                    v-model:checked="baseInfo.fuzzyMatch"
                    :disabled="
                      isView ||
                        ([RUNNING, PAUSED, PUBLISED, END].indexOf(
                          disableStatus
                        ) >= 0 &&
                          !!baseInfo.id)
                    "
                  >
                    是否精准匹配
                  </a-checkbox>
                  <a-tooltip>
                    <template #title
                      >不勾选默认模糊匹配，包含或者正则验证满足一个条件就可以参与后续分流判断</template
                    >
                    <QuestionCircleOutlined />
                  </a-tooltip>
                </a-form-item>
                <a-form-item label="实验描述">
                  <a-input
                    :disabled="
                      isView ||
                        ([PUBLISED, END].indexOf(disableStatus) >= 0 &&
                          !!baseInfo.id)
                    "
                    placeholder="请输入"
                    style="width: 300px;"
                    :maxlength="300"
                    v-model:value="baseInfo.testDesc"
                  />
                </a-form-item>
                <a-form-item label="运行时长" required>
                  <a-tooltip placement="top">
                    <template #title>
                      <span
                        >到期后实验将自动下线，实验状态变为‘已结束’，用户将走默认策略，到期前可调整运行时长</span
                      >
                    </template>
                    <QuestionCircleOutlined class="mr10" />
                  </a-tooltip>
                  <a-input-number
                    v-model:value="baseInfo.runTime"
                    :max="365"
                    :precision="0"
                    :min="
                      !!baseInfo.id && [TEST].indexOf(disableStatus) < 0
                        ? oldRunTime
                        : 1
                    "
                    :disabled="
                      isView ||
                        ([RUNNING, PUBLISED, END].indexOf(disableStatus) >= 0 &&
                          !!baseInfo.id)
                    "
                  /><span style="color: #000;margin-left: 10px;"
                    >(GMT+1时间)</span
                  >
                </a-form-item>
              </a-collapse-panel>
              <a-collapse-panel key="3" header="实验受众" forceRender>
                <a-form-item label="选择实验层" required>
                  <a-popover
                    title="选择实验层"
                    trigger="click"
                    position="bottom"
                    :visible="layerClicked"
                    @visibleChange="handleClickChange"
                  >
                    <template #content>
                      <a-tabs type="card" v-model:activeKey="layerType">
                        <a-tab-pane :key="1" tab="设备ID">
                          <div class="mb10">
                            <span>没有想要的实验层？</span
                            ><a-button
                              size="small"
                              :disabled="
                                isView ||
                                  (!!baseInfo.id &&
                                    [TEST].indexOf(disableStatus) < 0)
                              "
                              type="primary"
                              @click="layerDrawerVisible = true"
                              >新建</a-button
                            >
                          </div>
                          <a-select
                            :allow-clear="true"
                            :disabled="
                              isView ||
                                (!!baseInfo.id &&
                                  [TEST].indexOf(disableStatus) < 0)
                            "
                            v-model:value="baseInfo.layerId"
                            style="width: 200px"
                            placeholder="选择实验层"
                            show-search
                            :filterOption="filterOption"
                            @change="changeFlowRateLayer"
                          >
                            <a-select-option
                              v-for="item in layerList"
                              :key="item.id"
                              :value="item.id"
                              :label="item.name"
                              :disabled="item.unallocated === 0"
                            >
                              <a-tooltip placement="topLeft">
                                <template #title>
                                  <span>{{ item.name }}</span>
                                </template>
                                <p>{{ item.name }}</p>
                                <p>剩余可用流量{{ item.unallocated }}%</p>
                              </a-tooltip>
                            </a-select-option>
                          </a-select>
                        </a-tab-pane>
                      </a-tabs>
                    </template>
                    <layerDrawer
                      v-model:visible="layerDrawerVisible"
                      @submit="handleLayerSubmit"
                    />
                    <a-button
                      :disabled="
                        isView ||
                          (!!baseInfo.id && [TEST].indexOf(disableStatus) < 0)
                      "
                      v-if="
                        layerList.find(item => item.id == baseInfo.layerId)
                          ?.name
                      "
                    >
                      {{
                        layerList.find(item => item.id == baseInfo.layerId)
                          ?.name
                      }}
                    </a-button>

                    <a-button v-else :disabled="isView || !!baseInfo.id"
                      ><span style="color:#999">请选择实验层</span></a-button
                    >
                  </a-popover>
                </a-form-item>
                <a-form-item label="占用实验层比例" required="true">
                  <a-input-number
                    :disabled="
                      isView ||
                        ([RUNNING, PUBLISED, END].indexOf(disableStatus) >= 0 &&
                          !!baseInfo.id) ||
                        !baseInfo.layerId
                    "
                    id="inputNumber"
                    v-model:value="baseInfo.weight"
                    :min="1"
                    :max="layerMaxValue"
                    :step="1"
                    :precision="0"
                  />
                  <span style="margin-left: 4px;">%</span>
                  <span
                    v-if="baseInfo.layerId && layerMaxValue > 0"
                    style="margin-left: 6px;color: #9a9a9a"
                    >（可使用的范围：1% ~ {{ layerMaxValue }}%）</span
                  >
                </a-form-item>
                <a-form-item label="选取受众">
                  <a-radio-group
                    v-model:value="audiences.type"
                    :disabled="
                      isView ||
                        ([TEST].indexOf(disableStatus) < 0 && !!baseInfo.id)
                    "
                    @change="handleAudiencesChange"
                  >
                    <a-radio label="ALL" :value="1">全部受众</a-radio>
                    <a-radio label="筛选受众用户" :value="2"
                      >受众用户筛选</a-radio
                    >
                    <a-radio label="筛选受众用户" :value="3"
                      >指定已有用户群</a-radio
                    >
                  </a-radio-group>
                </a-form-item>
                <div v-if="audiences.type === 3" style="margin-top: 20px;">
                  <a-select
                    :allow-clear="true"
                    :disabled="
                      isView ||
                        ([TEST].indexOf(disableStatus) < 0 && !!baseInfo.id)
                    "
                    v-model:value="audiences.userGroupId"
                    style="width: 200px"
                    placeholder="指定已有用户群"
                    @popupScroll="handleScroll"
                    show-search
                    @search="handleUserGroupSearch"
                    :filter-option="false"
                    @change="handleUserGroupChange"
                  >
                    <a-select-option
                      v-for="item in userGroupOptions"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    >
                      <a-tooltip placement="topLeft">
                        <template #title>
                          <span>{{ item.label }}</span>
                        </template>
                        <TeamOutlined /> <span>{{ item.label }}</span>
                      </a-tooltip>
                    </a-select-option>
                  </a-select>
                </div>
                <div
                  v-if="audiences.type === 2"
                  style="margin-top: 20px;position:relative"
                  :style="{
                    marginLeft: audiences.groups.length > 1 ? '40px' : '0'
                  }"
                >
                  <div>
                    <div
                      v-for="(item, index) in audiences.groups"
                      :key="index"
                      class="mb20"
                      style="position:relative"
                      :style="{
                        marginLeft:
                          item.audienceDetails.length > 1 ? '40px' : '0'
                      }"
                    >
                      <div v-for="(n, idx) in item.audienceDetails" :key="idx">
                        <div style="display: flex">
                          <custom-select
                            style="width: 150px;"
                            :disabled="
                              isView ||
                                ([TEST].indexOf(disableStatus) < 0 &&
                                  !!baseInfo.id)
                            "
                            @update:value="e => onChange(e, n)"
                            v-model:value="n.type"
                            funType="select"
                            :list="typeList"
                          ></custom-select>
                          <custom-select
                            :disabled="
                              isView ||
                                ([TEST].indexOf(disableStatus) < 0 &&
                                  !!baseInfo.id)
                            "
                            v-model:value="n.ruleType"
                            funType="select"
                            style="margin-left: 20px; width: 150px;"
                            :list="
                              n.type === URL
                                ? CONDITION_RULES[2]
                                : CONDITION_RULES[0]
                            "
                          ></custom-select>
                          <custom-select
                            v-if="n.type !== REGION"
                            v-model:value="n.content"
                            style="margin-left: 20px;width: 180px"
                            :funType="
                              n.type == UTMPARAM || n.type == URL
                                ? 'input'
                                : 'select'
                            "
                            :disabled="
                              isView ||
                                ([TEST].indexOf(disableStatus) < 0 &&
                                  !!baseInfo.id)
                            "
                            :list="userTypeRule[n.type]"
                          ></custom-select>
                          <template v-else>
                            <a-select
                              :disabled="
                                isView ||
                                  ([TEST].indexOf(disableStatus) < 0 &&
                                    !!baseInfo.id)
                              "
                              v-model:value="n.geoInfo.country"
                              show-search
                              placeholder="请选择国家"
                              style="margin-left:20px;width: 200px"
                              :filter-option="handleSearch"
                              @change="val => handleAddressChange(n, val, 1)"
                            >
                              <a-select-option
                                v-for="(addressItem, i) in countrys"
                                :key="i"
                                :value="addressItem.countryRegionCode"
                                :label="addressItem.nameEn"
                                >{{ addressItem.nameEn }}</a-select-option
                              >
                            </a-select>
                            <a-select
                              :disabled="
                                isView ||
                                  ([TEST].indexOf(disableStatus) < 0 &&
                                    !!baseInfo.id)
                              "
                              v-model:value="n.geoInfo.region"
                              show-search
                              v-show="n.provinces?.length"
                              placeholder="请选择省州"
                              style="width: 200px"
                              :filter-option="handleSearch"
                              @change="val => handleAddressChange(n, val, 2)"
                            >
                              <a-select-option
                                v-for="(addressItem, i) in n.provinces"
                                :key="i"
                                :value="addressItem.countryRegionCode"
                                :label="addressItem.nameEn"
                                >{{ addressItem.nameEn }}</a-select-option
                              >
                            </a-select>
                            <a-select
                              :disabled="
                                isView ||
                                  ([TEST].indexOf(disableStatus) < 0 &&
                                    !!baseInfo.id)
                              "
                              v-show="n.citys?.length"
                              v-model:value="n.geoInfo.city"
                              show-search
                              placeholder="请选择城市"
                              style="width: 200px"
                              :filter-option="handleSearch"
                            >
                              <a-select-option
                                v-for="(addressItem, i) in n.citys"
                                :key="i"
                                :value="addressItem.nameEn"
                                :label="addressItem.nameEn"
                                >{{ addressItem.nameEn }}</a-select-option
                              >
                            </a-select>
                          </template>
                          <a-button
                            :disabled="
                              isView ||
                                ([TEST].indexOf(disableStatus) < 0 &&
                                  !!baseInfo.id)
                            "
                            @click="addAudience(index)"
                            type="link"
                            v-if="idx === 0"
                          >
                            <PlusOutlined />并且满足
                          </a-button>
                          <a-button
                            :disabled="
                              isView ||
                                ([TEST].indexOf(disableStatus) < 0 &&
                                  !!baseInfo.id)
                            "
                            @click="deleteAudience(index, idx)"
                            type="link"
                          >
                            <CloseOutlined />删除
                          </a-button>
                        </div>
                        <affect v-if="item.audienceDetails.length > 1">
                          <div
                            style="display:flex;flex-direction:column;justify-content:center"
                          >
                            <a-radio-group
                              v-model:value="item.logic"
                              buttonStyle="solid"
                              :disabled="
                                isView ||
                                  ([TEST].indexOf(disableStatus) < 0 &&
                                    !!baseInfo.id)
                              "
                              style="display:flex;flex-direction:column"
                              size="small"
                            >
                              <a-radio-button :value="1">且</a-radio-button>
                              <a-radio-button :value="2">或</a-radio-button>
                            </a-radio-group>
                          </div>
                        </affect>
                      </div>
                    </div>
                  </div>
                  <affect v-if="audiences.groups.length > 1">
                    <div
                      style="display:flex;flex-direction:column;justify-content:center"
                    >
                      <a-radio-group
                        v-model:value="audiences.logic"
                        buttonStyle="solid"
                        :disabled="
                          isView ||
                            ([TEST].indexOf(disableStatus) < 0 && !!baseInfo.id)
                        "
                        style="display:flex;flex-direction:column"
                        size="small"
                      >
                        <a-radio-button :value="1">且</a-radio-button>
                        <a-radio-button :value="2">或</a-radio-button>
                      </a-radio-group>
                    </div>
                  </affect>
                </div>
                <a-button
                  :disabled="
                    isView ||
                      ([TEST].indexOf(disableStatus) < 0 && !!baseInfo.id) ||
                      audiences.groups.length >= 3
                  "
                  v-if="audiences.type === 2"
                  type="primary"
                  class="mt10"
                  @click="addGroupItem"
                  ><PlusOutlined />添加筛选</a-button
                >
              </a-collapse-panel>

              <a-collapse-panel
                key="4"
                header="设置分组"
                forceRender
                class="cds"
              >
                <a-form-item label="分配方式">
                  <a-radio-group v-model:value="issueType">
                    <!-- <a-radio label="2" :value="1">平均分配</a-radio> -->
                    <a-radio label="2" :value="2">手动分配</a-radio>
                  </a-radio-group>
                </a-form-item>
                <div style="margin-top: 20px;">
                  <a-row
                    :gutter="[
                      { xs: 16, sm: 16, md: 16, lg: 16 },
                      { xs: 16, sm: 16, md: 16, lg: 16 }
                    ]"
                  >
                    <a-col
                      :xs="24"
                      :sm="12"
                      :md="8"
                      :lg="8"
                      :xl="6"
                      v-for="(item, idx) in variants"
                      :key="idx"
                    >
                      <a-card style="width: 100%;min-height: 350px;">
                        <a-form-item label="组id" style="margin-left:15px">
                          {{ item.id }}
                        </a-form-item>
                        <a-form-item label="分组名称" required>
                          <!-- class="border-transparent" -->
                          <a-input
                            v-if="idx > 0"
                            :disabled="
                              isView ||
                                ([TEST].indexOf(disableStatus) < 0 &&
                                  !!baseInfo.id)
                            "
                            :maxlength="100"
                            v-model:value="item.name"
                            placeholder="请输入"
                          />
                          <text v-if="item.name === '默认实验' && idx === 0">{{
                            item.name
                          }}</text>
                        </a-form-item>
                        <a-button
                          type="link"
                          class="preview"
                          @click="showDialog"
                          v-if="idx > 0"
                          >预览</a-button
                        >
                        <a-form-item label="流量比例" required>
                          <a-input-number
                            :disabled="
                              isView ||
                                ([PUBLISED, END].indexOf(disableStatus) >= 0 &&
                                  !!baseInfo.id)
                            "
                            v-if="idx > 0"
                            style="width: 80px;"
                            v-model:value="item.weight"
                            :max="100"
                            :step="1"
                            :precision="0"
                            @change="changeNumber"
                          />
                          <a-input-number
                            v-else
                            :disabled="true"
                            style="width: 80px;"
                            v-model:value="item.weight"
                            :max="100"
                            :min="0"
                            :step="1"
                            :precision="0"
                          />
                          <!-- <text v-if="item.name === '默认实验' && idx === 0">{{
                            variants[0].weight.toFixed(0)
                          }}</text
                          > -->
                          <span style="margin-left: 5px">%</span>
                        </a-form-item>
                        <div>备注信息:</div>
                        <div style="display: flex;">
                          <a-form-item style="flex: 1;">
                            <a-textarea
                              resize="none"
                              :maxlength="300"
                              :disabled="
                                isView ||
                                  ([PUBLISED, END].indexOf(disableStatus) >=
                                    0 &&
                                    !!baseInfo.id)
                              "
                              v-model:value="item.description"
                              placeholder="请输入"
                            />
                          </a-form-item>
                        </div>
                        <div>
                          <a-row :gutter="2">
                            <a-col span="12">
                              <a-form-item>
                                <a-upload
                                  class="avatar-uploader"
                                  :disabled="
                                    isView ||
                                      ([PUBLISED, END].indexOf(disableStatus) >=
                                        0 &&
                                        !!baseInfo.id)
                                  "
                                  v-model:fileList="fileList"
                                  :show-upload-list="false"
                                  name="avatar"
                                  :multiple="true"
                                  :customRequest="e => upload(e, idx)"
                                  :accept="'.png,.jpg,.jpeg,.gif'"
                                  :headers="headers"
                                  :remove="false"
                                >
                                  <img
                                    :src="item.imageDesc"
                                    alt=""
                                    v-if="item.imageDesc"
                                    style="max-width: 80px; height: 80px; cursor: pointer;border:1px solid #ededed"
                                  />
                                  <div
                                    v-else
                                    style="width: 76px; height: 76px;text-align: center;border: 1px dashed #d9d9d9;background-color: #fafafa;display: flex; flex-direction: column; align-items: center; justify-content: center; cursor: pointer;"
                                  >
                                    <plus-outlined></plus-outlined>
                                    <div style="font-size: 12px;">上传图片</div>
                                  </div>
                                </a-upload>
                              </a-form-item>
                            </a-col>
                            <!-- <a-col :span="12">
                              <div style="margin-bottom: 12px">
                                <a-tooltip>
                                  <a-button
                                    type="link"
                                    @click="showScript(item, idx)"
                                    v-if="idx > 0"
                                  >
                                    +自定义脚本
                                  </a-button>
                                  <template #title v-if="item.scriptContent">
                                    {{ item.scriptContent }}
                                  </template>
                                </a-tooltip>
                                <a-modal
                                  v-model:visible="scriptVisible"
                                  title="自定义脚本"
                                  @ok="okScript"
                                  okText="确定"
                                  cancelText="取消"
                                >
                                  <a-textarea
                                    :disabled="
                                      [PUBLISED, END].indexOf(disableStatus) >=
                                        0 && !!baseInfo.id
                                    "
                                    v-model:value="newParams.scriptContent"
                                    placeholder="多行输入"
                                    :auto-size="{ minRows: 20 }"
                                  />
                                </a-modal>
                              </div>
                              <div>
                                <a-tooltip>
                                  <a-button
                                    type="link"
                                    @click="showCss(item, idx)"
                                    v-if="idx > 0"
                                  >
                                    +添加自定义样式
                                  </a-button>
                                  <template #title v-if="item.cssContent">
                                    {{ item.cssContent }}
                                  </template>
                                </a-tooltip>
                                <a-modal
                                  v-model:visible="cssVisible"
                                  title="添加自定义样式"
                                  @ok="okCss"
                                  okText="确定"
                                  cancelText="取消"
                                >
                                  <VAceEditor
                                    v-model:value="newCss.cssContent"
                                    style="height: 300px"
                                    lang="css"
                                    :options="{
                                      readonly:
                                        [PUBLISED, END].indexOf(
                                          disableStatus
                                        ) >= 0 && !!baseInfo.id
                                    }"
                                    :readonly="
                                      [PUBLISED, END].indexOf(disableStatus) >=
                                        0 && !!baseInfo.id
                                    "
                                  />
                                </a-modal>
                              </div>
                            </a-col> -->
                          </a-row>
                        </div>
                        <a-form-item label="调试设备">
                          <div class="mb10 mt5">
                            没有想要的设备？<a-button
                              type="primary"
                              size="small"
                              :disabled="
                                isView ||
                                  ([PUBLISED, END].indexOf(disableStatus) >=
                                    0 &&
                                    !!baseInfo.id)
                              "
                              @click="deviceVisible = true"
                              >新增</a-button
                            >
                          </div>
                          <a-select
                            v-model:value="item.deviceIds"
                            mode="multiple"
                            :disabled="
                              isView ||
                                ([PUBLISED, END].indexOf(disableStatus) >= 0 &&
                                  !!baseInfo.id)
                            "
                            style="width: 100%;margin-left:-30px"
                            placeholder="请选择"
                            show-search
                            :filterOption="filterOption"
                            :options="deviceList"
                          >
                          </a-select>
                          <DeviceDrawer></DeviceDrawer>
                        </a-form-item>
                        <div>
                          <a-table
                            size="small"
                            :dataSource="item.customParam"
                            :columns="columns"
                            :pagination="false"
                          >
                            <template #actionTitle>
                              <a-button
                                v-if="item.name === '默认实验' && idx === 0"
                                :disabled="
                                  isView ||
                                    item.customParam.length >= 5 ||
                                    ([TEST].indexOf(disableStatus) < 0 &&
                                      !!baseInfo.id)
                                "
                                type="primary"
                                size="small"
                                @click="addSelfKeyValue(item)"
                              >
                                <template #icon><PlusOutlined /></template>
                              </a-button>
                            </template>
                            <template #name="{ record, index }">
                              <a-tooltip>
                                <template #title>{{ record.name }}</template>
                                <a-input
                                  :disabled="
                                    isView ||
                                      idx > 0 ||
                                      ([TEST].indexOf(disableStatus) < 0 &&
                                        !!baseInfo.id)
                                  "
                                  v-model:value="record.name"
                                  :maxlength="30"
                                  @change="e => changeValue(e, index)"
                                ></a-input>
                              </a-tooltip>
                            </template>
                            <template #value="{ record }">
                              <a-tooltip>
                                <template #title>{{ record.value }}</template>
                                <a-input
                                  :disabled="
                                    isView ||
                                      ([TEST].indexOf(disableStatus) < 0 &&
                                        !!baseInfo.id)
                                  "
                                  v-model:value="record.value"
                                ></a-input>
                              </a-tooltip>
                            </template>
                            <template #action="{index}">
                              <a-button
                                :disabled="
                                  isView ||
                                    ([TEST].indexOf(disableStatus) < 0 &&
                                      !!baseInfo.id)
                                "
                                v-if="item.name == '默认实验' && idx === 0"
                                type="danger"
                                size="small"
                                @click="deleteSelfKeyValue(item, index)"
                              >
                                <template #icon><MinusOutlined /></template>
                              </a-button>
                            </template>
                          </a-table>
                        </div>
                        <a-form-item
                          style="flex: 1;margin-top:16px"
                          label="url"
                          v-if="baseInfo.type == 1"
                        >
                          <a-input
                            resize="none"
                            :maxlength="2000"
                            v-model:value="item.url"
                            placeholder="请输入"
                          />
                        </a-form-item>
                      </a-card>
                    </a-col>
                    <a-col :xs="24" :sm="12" :md="8" :lg="8" :xl="6">
                      <a-card
                        style="width: 100%;min-height: 350px;display: flex;align-items: center;justify-content: center;"
                      >
                        <a-button
                          :disabled="
                            isView ||
                              ([TEST].indexOf(disableStatus) < 0 &&
                                !!baseInfo.id)
                          "
                          @click="ListPush1(variants)"
                          v-if="variants.length < 10"
                          >+添加实验分组</a-button
                        >
                      </a-card>
                    </a-col>
                  </a-row>
                </div>
              </a-collapse-panel>
              <!-- <a-collapse-panel key="5" header="设置指标" forceRender>
                <a-modal
                  v-model:visible="metricVisible"
                  title="可选指标"
                  @ok="handleMetricOk"
                  ok-text="确认"
                  cancel-text="取消"
                  @cancel="
                    () => {
                      metricVisible = false
                      metricValues = []
                    }
                  "
                >
                  <div style="overflow: auto; height: 200px">
                    <a-checkbox-group v-model:value="metricValues">
                      <a-checkbox
                        @change="changeMetric"
                        :disabled="
                          metricValues.length > 9 &&
                            metricValues.indexOf(item.id) < 0
                        "
                        v-for="item in metricCheckBoxList"
                        :key="item.id"
                        :value="item.id"
                        style="margin-bottom: 4px;margin-right: 4px;margin-left: 0px;"
                        >{{ item.optionName }}</a-checkbox
                      >
                    </a-checkbox-group>
                  </div>
                </a-modal>
                <div style="margin-bottom: 10px; text-align: right">
                  <a-button
                    @click="getAbtestMetricModal"
                    type="primary"
                    :disabled="[1, 2].indexOf(disableStatus) >= 0"
                    >添加指标</a-button
                  >
                </div>
                <a-table
                  :dataSource="abMetricConfigDTOS"
                  :columns="abMetricColumns"
                  :pagination="false"
                  size="small"
                >
                  <template #optionName="{record}">
                    {{ record.optionName }}
                    <a-tag v-if="record.coreTag === 1" color="orange"
                      >核心</a-tag
                    >
                  </template>
                  <template #action="{ record, index }">
                    <a-button
                      type="link"
                      :disabled="[1, 2].indexOf(disableStatus) >= 0"
                      @click="removeAbtestMetric(record, index)"
                      >移除</a-button
                    >
                    <a-button
                      v-if="record.coreTag === 1"
                      :disabled="[1, 2].indexOf(disableStatus) >= 0"
                      type="link"
                      @click="changeAbtestMetricStatus(record, 0)"
                      >取消核心指标</a-button
                    >
                    <a-button
                      v-else
                      type="link"
                      :disabled="[1, 2].indexOf(disableStatus) >= 0"
                      @click="changeAbtestMetricStatus(record, 1)"
                      >设为核心指标</a-button
                    >
                  </template>
                </a-table>
              </a-collapse-panel> -->
            </a-collapse>
            <div class="btn">
              <a-button style="margin-right: 50px;" @click="cancel"
                >取消</a-button
              >
              <a-button type="primary" @click="save" :disabled="isView"
                >保存</a-button
              >
            </div>
            <Iframe v-model:show="modalVisible" :sourceObj="sourceObj"></Iframe>
          </a-form>
        </div>
      </a-tab-pane>
      <!-- <a-tab-pane
        forceRender
        :disabled="isReport === '0'"
        key="2"
        tab="实验报告"
      >
        <div class="report-title">
          实验概述
        </div>
        <div class="report-content">
          在[{{ reportBasicInfo.startTime }}]至[{{
            reportBasicInfo.endTime
          }}]，共计运行{{ reportBasicInfo.runningDays }}天
        </div>
        <div class="report-title">数据总览</div>
        <div class="report-content">
          <div class="flex">
            <div>选择日期：</div>
            <a-range-picker
              v-model:value="reportDate"
              format="YYYY-MM-DD"
              :allow-clear="false"
              :disabled-date="disabledDate"
            >
            </a-range-picker>
            <div class="flex" style="margin-left:20px">
              <div>观测指标：</div>
              <a-select v-model:value="metricsId" style="min-width: 300px">
                <a-select-option
                  v-for="(item, index) in metricsOptions"
                  :value="item.abtestMetricOptionId"
                  :key="index"
                >
                  {{ item.optionName }}
                </a-select-option>
              </a-select>
            </div>
          </div>
          <div
            v-if="showEcharts"
            id="ab-echarts"
            style="height:500px;margin-top:40px"
          ></div>
        </div>
      </a-tab-pane> -->
    </a-tabs>
  </div>
</template>
<script>
import {
  defineComponent,
  ref,
  reactive,
  onMounted,
  toRefs,
  h,
  watch,
  onUnmounted,
  computed,
  provide
} from 'vue'
import { debounce } from 'lodash-es'
import {
  rule as selectRule,
  userRule,
  userTypeRule,
  userProperties,
  userLabels,
  userActions,
  AudienceType,
  CONDITION_RULES
} from './select.data'
import affect from './components/affect.vue'
import layerDrawer from './components/layerDrawer.vue'
import { useRoute, useRouter } from 'vue-router'
import { message, Modal } from 'ant-design-vue'
import customSelect from './components/custom-select.vue'
// import { VAceEditor } from 'vue3-ace-editor'
import * as echarts from 'echarts'
import dayjs from 'dayjs'
import {
  PlusOutlined,
  MinusOutlined,
  CloseOutlined,
  TeamOutlined
} from '@ant-design/icons-vue'
import Iframe from './components/Iframe.vue'
import {
  abtest_new_query_get,
  abtest_new_save_post
} from './../../server/modules/91176'
import { abtest_select_post } from '@/server/modules/10982'
import {
  abtest_listAbtestMetricOption_get,
  abtest_getAbReportInfo_post,
  abtest_getAbReportBaseInfo_get
} from './../../server/modules/12627'
import { post_abLayer_new_queryAll } from '@/server/modules/21934'
import { user_group_list_post } from '@/server/modules/549'
import { formRequest } from 'cupshe-axios'
import { collection_list_post } from '@/server/modules/635'
import { getUiniqId } from '@/server/modules/filter'
import ace from 'ace-builds'
import { post_abDevice_queryAll } from '@/server/modules/21937'
import { QuestionCircleOutlined } from '@ant-design/icons-vue'
import DeviceDrawer from './components/deviceDrawer.vue'
import CollectionList from './components/CollectionList.vue'
import {
  statusOptionList,
  DRAFT,
  TEST,
  RUNNING,
  PAUSED,
  PUBLISED,
  END
} from '../ABtestV3/ruleData'
ace.config.set(
  'basePath',
  'https://cupshe-cdn.oss-cn-hangzhou.aliyuncs.com/web/CMC/ace-builds@1.4.12/src-noconflict'
)

export default defineComponent({
  components: {
    QuestionCircleOutlined,
    affect,
    CollectionList,
    // VAceEditor,
    // PlusOutlined,
    // LoadingOutlined,
    CloseOutlined,
    PlusOutlined,
    MinusOutlined,
    TeamOutlined,
    Iframe,
    customSelect,
    layerDrawer,
    DeviceDrawer
    // VNodes: (_, { attrs }) => {
    //   return attrs.vnodes
    // }
  },
  setup() {
    // const now = dayjs()
    const router = useRouter()
    const route = useRoute()
    const activeKey = ref(['1', '2', '3', '4', '5', '6'])
    let myChart = null
    // const today = dayjs()
    // // 获取14天后的日期
    // const future14Days = dayjs().add(14, 'day')
    const {
      REGION,
      DEVICE_TYPE,
      VISTOR,
      CUSTOMER,
      LOGIN_STATUS,
      SUBSCRIBE_STATUS,
      UTMPARAM,
      CHANNEL,
      URL
    } = AudienceType
    const state = reactive({
      DRAFT,
      TEST,
      RUNNING,
      PAUSED,
      PUBLISED,
      END,
      REGION,
      DEVICE_TYPE,
      VISTOR,
      CUSTOMER,
      LOGIN_STATUS,
      SUBSCRIBE_STATUS,
      UTMPARAM,
      CHANNEL,
      URL,
      oldRunTime: 1,
      statusOptionList,
      userType: 1,
      layerType: 1,
      collectionIdDatas: [],
      fetching: false,
      layerDrawerVisible: false,
      layerClicked: false,
      layerList: [],
      deviceList: [],
      geoOptions: [],
      lastFetchId: 1,
      isReport: '0',
      isApp: false,
      // pageModalOptions: [],
      metricsOptions: [],
      metricsId: null,
      deviceVisible: false,
      isView: false,
      handleClickChange() {
        state.layerClicked = !state.layerClicked
      },
      showEcharts: false,
      reportDate: [],
      defaultPickerValue: [],
      reportBasicInfo: [],
      uniqueId: null,
      fetchUser: debounce(async value => {
        state.lastFetchId += 1
        const fetchId = state.lastFetchId
        state.collectionIdDatas = []
        state.fetching = true
        const { success, data } = await collection_list_post({
          collectionId: value,
          pageNum: 1,
          uniqueId: state.uniqueId,
          pageSize: 25
        })
        if (fetchId !== state.lastFetchId) {
          // for fetch callback order
          return
        }
        if (success) {
          const datas = data.list.map(item => ({
            label: item.collectId,
            value: item.collectId
          }))
          state.collectionIdDatas = datas
          state.fetching = false
        }
      }, 300),
      collectionShow: false,
      collectionType: 'edit',
      showCollectionList(type) {
        state.collectionShow = true
        state.collectionType = type
      },
      updateCollectionIds(ids) {
        state.baseInfo.collectionIds = ids
      },
      getDeviceList: async () => {
        const { success, data } = await post_abDevice_queryAll({})
        if (success) {
          state.deviceList = data.map(item => ({
            label: item.name + ':' + item.distinctId,
            value: item.id
          }))
        }
      },
      disabledDate(current) {
        const startDate = dayjs(state.reportBasicInfo.startTime)
        const endDate = dayjs(state.reportBasicInfo.endTime)
        return (
          current && (current.isBefore(startDate) || current.isAfter(endDate))
        )
      },
      getMetricsInfo: async () => {
        const { brandId, siteId, channelId, terminalId } = state.baseInfo
        const { success, data } = await abtest_getAbReportInfo_post({
          brandId,
          siteId,
          channelId,
          terminalId,
          baseId: route.query.id,
          startTime: state.reportDate[0].format('YYYY-MM-DD'),
          endTime: state.reportDate[1].format('YYYY-MM-DD'),
          abtestMetricOptionId: state.metricsId
        })
        if (success) {
          if (!myChart && !data.variants?.length) return
          if (myChart) {
            myChart.clear()
            myChart = null
            if (!data.variants?.length) return
          }
          let option = {
            tooltip: {
              trigger: 'axis'
            },
            legend: { data: data.variants.map(item => item.name) },
            grid: {
              left: '8%',
              right: '10%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              name: '日期',
              nameTextStyle: {
                color: '#000',
                fontSize: 20
              },
              boundaryGap: false,
              data: []
            },
            yAxis: {
              type: 'value',
              name: `${data.unitName}`,
              nameTextStyle: {
                color: '#000',
                fontSize: 20
              },
              axisLabel: {
                formatter: function(value) {
                  return parseInt(value) // 将标签值转换为整数
                }
              }
            }
          }
          let timeArr = []
          data.variants.forEach(item => {
            timeArr = timeArr.concat(
              item.experimentDataPointList.map(n => n.date)
            )
          })
          timeArr = [...new Set(timeArr)]
          option.xAxis.data = timeArr.sort()
          option.series = data.variants.map(item => ({
            name: item.name,
            type: 'line',
            label: {
              show: true,
              position: 'top'
            },
            data: state.hanldeDateValue(timeArr, item.experimentDataPointList)
          }))

          state.initEcharts(option)
        }
      },
      hanldeDateValue(timeArr, list) {
        const arr = timeArr.map(() => 0)
        list.forEach(item => {
          const index = timeArr.findIndex(n => item.date === n)
          index > -1 && (arr[index] = item.value)
        })
        return arr
      },
      getReportBasicInfo: async () => {
        const { brandId, siteId, channelId, terminalId } = state.baseInfo
        const { success, data } = await abtest_getAbReportBaseInfo_get({
          brandId,
          siteId,
          channelId,
          terminalId,
          baseId: route.query.id
        })
        if (success) {
          state.reportBasicInfo = data
          state.metricsOptions = data.abMetricConfigDTOS
          state.metricsId = state.metricsOptions[0]?.abtestMetricOptionId
        }
      },
      initEcharts(option) {
        // 基于准备好的dom，初始化echarts实例
        !myChart &&
          (myChart = echarts.init(document.getElementById('ab-echarts')))
        myChart.setOption(option)
      },
      layerMaxValue: 100,
      filterOption: (input, option) => {
        return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      changeFlowRateLayer: val => {
        state.layerList.forEach(item => {
          if (item.id === val) {
            state.layerMaxValue = item.unallocated
          }
        })
        state.baseInfo.weight = null
      },
      handleLayerSubmit: data => {
        state.layerClicked = false
        state.getLayorList(data.name)
      },
      getLayorList: async () => {
        const { brandId, siteId, channelId, terminalId } = state.baseInfo
        const { success, data } = await post_abLayer_new_queryAll({
          brandId,
          siteId,
          channelId,
          terminalId
        })
        if (success) {
          state.layerList = data

          if (state.baseInfo.layerId) {
            // let weight = 0
            // if (state.isCopy) {
            //   weight = 0
            // } else {
            //   weight = state.baseInfo.weight
            // }
            state.layerList.forEach(item => {
              if (item.id === state.baseInfo.layerId) {
                if ([PAUSED].includes(state.baseInfo.status)) {
                  state.layerMaxValue =
                    item.unallocated + state.baseInfo.weight || 0
                } else {
                  state.layerMaxValue = item.unallocated
                }
              }
            })
          }
        }
      },
      getGeoData: async () => {
        // 这里应该调用获取地理位置数据的接口
        // 示例数据结构
        state.geoOptions = [
          {
            value: 'US',
            label: 'United States',
            children: [
              {
                value: 'CA',
                label: 'California',
                children: [
                  {
                    value: 'LA',
                    label: 'Los Angeles'
                  }
                ]
              }
            ]
          }
        ]
      },
      activeTabKey: '1',
      userGroupInfo: {
        pageSize: 100000,
        pageNum: 1,
        totalPages: 0,
        userGroupName: ''
      },
      handleUserGroupChange: async val => {
        if (!val) {
          state.handleUserGroupSearch('')
        }
      },
      handleUserGroupSearch: debounce(async val => {
        state.userGroupInfo.userGroupName = val
        state.userGroupInfo.pageNum = 1
        const { brandId, siteId, channelId, terminalId } = state.baseInfo
        const { success, data } = await user_group_list_post({
          brandId,
          siteId,
          channelId,
          terminalId,
          ...state.userGroupInfo
        })
        if (success) {
          let options = data.list.map(i => {
            return {
              label: i.userGroupName,
              value: i.userGroupId
            }
          })
          state.userGroupOptions = options
          state.userGroupInfo.totalPages = Math.ceil(data.total / data.pageSize)
        }
      }, 500),
      userGroupOptions: [],
      handleScroll: e => {
        const target = e.target

        if (target.scrollTop + target.clientHeight >= target.scrollHeight) {
          state.userGroupInfo.pageNum++
          if (state.userGroupInfo.pageNum > state.userGroupInfo.totalPages)
            return
          state.getUserGroupList()
        }
      },
      getUserGroupList: async () => {
        const { brandId, siteId, channelId, terminalId } = state.baseInfo
        const { success, data } = await user_group_list_post({
          brandId,
          siteId,
          channelId,
          terminalId,
          ...state.userGroupInfo
        })
        if (success) {
          let options = data.list.map(i => {
            return {
              label: i.userGroupName,
              value: i.userGroupId
            }
          })
          state.userGroupOptions = [...state.userGroupOptions, ...options]
          state.userGroupInfo.totalPages = Math.ceil(data.total / data.pageSize)
        } else {
          state.userGroupOptions = []
        }
        state.userGroupInfo.userGroupIdList = []
      },
      changeValue: (e, index) => {
        state.variants.forEach(i => {
          if (i.name !== '默认实验') {
            i.customParam[index].name = e.target.value
          }
        })
      },
      options: [
        { label: 'k1', value: 'k1' },
        { label: 'k2', value: 'k2' },
        { label: 'k3', value: 'k3' }
      ],
      columns: [
        {
          title: '参数名称',
          dataIndex: 'name',
          key: 'name',
          slots: {
            customRender: 'name'
          }
        },
        {
          title: '参数值',
          dataIndex: 'value',
          key: 'value',
          slots: {
            customRender: 'value'
          }
        },
        {
          key: 'action',
          width: 25,
          slots: {
            title: 'actionTitle',
            customRender: 'action'
          }
        }
      ],
      addSelfKeyValue: item => {
        if (!item.customParam) {
          item.customParam = []
        }
        state.variants.forEach(i => {
          i.customParam.push({
            name: '',
            value: ''
          })
        })
      },
      deleteSelfKeyValue: (item, index) => {
        state.variants.forEach(i => {
          i.customParam.splice(index, 1)
        })
        // item.customParam.splice(index, 1)
      },
      disableStatus: 1,
      fileList: [],
      people: 1,
      typeSave: '',
      statusSave: '',
      idSave: '',
      nameSave: '',
      modalVisible: false,
      sourceObj: {},
      newParams: {},
      newCss: {},
      index: 0,
      cssIndex: 0,
      issueType: 2,
      urlRule: false,
      nameRule: false,
      weightRule: false,
      loading: false,
      countrys: [],
      isCopy: false,
      metricVisible: false,
      metricValues: [],
      metricCheckBoxList: [],
      abMetricConfigImport: {},
      changeMetric: e => {
        let value = e.target.value
        let checked = e.target.checked
        state.metricCheckBoxList.forEach(i => {
          if (i.id === value && checked === false) {
            i.coreTag = 0
          }
        })
      },
      changeAbtestMetricStatus: (record, status) => {
        record.coreTag = status
        state.metricCheckBoxList.forEach(i => {
          if (i.id === record.id) {
            i.coreTag = status
          }
        })
      },
      removeAbtestMetric: (record, index) => {
        state.abMetricConfigDTOS.splice(index, 1)
        state.metricValues = state.abMetricConfigDTOS.map(i => i.id)
        state.metricCheckBoxList.forEach(i => {
          if (i.id === record.id) {
            i.coreTag = 0
          }
        })
      },
      handleMetricOk: () => {
        let abMetricConfigDTOS = []
        state.metricCheckBoxList.forEach(i => {
          if (state.metricValues.indexOf(i.id) >= 0) {
            abMetricConfigDTOS.push({
              ...i
            })
          }
        })
        state.metricVisible = false
        state.abMetricConfigDTOS = abMetricConfigDTOS
      },
      getAbtestMetricModal: async () => {
        state.metricVisible = true
        state.metricValues = state.abMetricConfigDTOS.map(i => i.id)
      },
      getMatricList: async () => {
        const { success, data } = await abtest_listAbtestMetricOption_get()
        if (success) {
          state.metricCheckBoxList = data.map(i => {
            return {
              ...i,
              abtestMetricOptionId: i.id,
              coreTag: 0
            }
          })

          if (state.abMetricConfigDTOS.length > 0) {
            let checked = []
            for (let i = 0; i < state.abMetricConfigDTOS.length; i++) {
              if (state.abMetricConfigDTOS[i].coreTag) {
                checked.push(state.abMetricConfigDTOS[i].id)
              }
            }
            state.metricCheckBoxList.forEach(i => {
              if (checked.indexOf(i.id) >= 0) {
                i.coreTag = 1
              }
            })
          }
        }
      },
      abMetricColumns: [
        {
          title: '指标名称',
          dataIndex: 'optionName',
          key: 'optionName',
          slots: {
            customRender: 'optionName'
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          width: 300,
          slots: {
            customRender: 'action'
          }
        }
      ],
      abMetricConfigDTOS: [],
      baseInfo: {
        testDesc: null,
        endTime: null,
        name: null,
        runTime: 14,
        startTime: null,
        type: null,
        brandId: 1,
        channelId: 1,
        siteId: 1,
        terminalId: 1,
        id: '',
        fuzzyMatch: false,
        collectionIds: [],
        status: 1
      },
      // urlPosition: {
      //   urlPositionGroups: [{ detailList: [{ type: 1, content: '' }] }],
      //   id: ''
      // },
      audiences: {
        groups: [
          {
            audienceDetails: [
              {
                type: 0,
                content: '',
                ruleType: '',
                userContent: '',
                geoInfo: {
                  city: '',
                  country: '',
                  region: ''
                },
                mobileInfo: {
                  deviceType: '',
                  version: ''
                }
              }
            ],
            id: '',
            type: 0,
            logic: 1
          }
        ],
        id: '',
        logic: 1,
        type: 1,
        userGroupId: ''
      },
      variants: [
        {
          id: '',
          name: '默认实验',
          description: '',
          imageDesc: '',
          weight: 1,
          scriptContent: '',
          deviceIds: [],
          cssContent: '',
          url: '',
          customParam: []
        }
      ],
      handleAudiencesChange() {
        if (state.audiences.type === 2) {
          state.audiences = {
            id: '',
            type: 2,
            logic: 1,
            userGroupId: '',
            groups: [
              {
                audienceDetails: [
                  {
                    type: 0,
                    content: '',
                    ruleType: 0,
                    userContent: '',
                    geoInfo: {
                      city: '',
                      country: '',
                      region: ''
                    },
                    mobileInfo: {
                      deviceType: '',
                      version: ''
                    }
                  }
                ],
                id: '',
                logic: 1
              }
            ]
          }
        }
        if (state.audiences.type === 3) {
          state.audiences = {
            id: '',
            type: 3,
            logic: null,
            userGroupId: '',
            groups: []
          }
        }
      },
      addGroupItem() {
        state.audiences.groups.push({
          audienceDetails: [
            {
              type: 0,
              content: '',
              ruleType: 0,
              userContent: '',
              geoInfo: {
                city: '',
                country: '',
                region: ''
              },
              mobileInfo: {
                deviceType: '',
                version: ''
              }
            }
          ],
          id: '',
          logic: 1
        })
      },
      addAudience: groupIndex => {
        state.audiences.groups[groupIndex].audienceDetails.push({
          type: 0,
          content: '',
          ruleType: 0,
          userContent: '',
          geoInfo: {
            city: '',
            country: '',
            region: ''
          },
          mobileInfo: {
            deviceType: '',
            version: ''
          }
        })
      },
      deleteAudience: (groupIndex, audienceIndex) => {
        state.audiences.groups[groupIndex].audienceDetails.splice(
          audienceIndex,
          1
        )
        if (state.audiences.groups[groupIndex].audienceDetails.length === 0) {
          state.audiences.groups.splice(groupIndex, 1)
        }
      },
      upload: (info = null, index) => {
        const isLt1M = info.file.size / 1024 / 1024 < 1
        if (!isLt1M) {
          message.error('图片大小不能超过1MB!')
          return
        }
        state.fileList = [info.file]
        state.info = info
        state.uploadHandleChange(index)
      },
      uploadHandleChange: async index => {
        const { info } = state
        if (info && info.file) {
          const api = `${process.env.VUE_APP_CMS}/cms/material/upload`
          const { success, retInfo, data } = await formRequest(api, {
            file: info.file
          })
          if (success) {
            state.variants[index].imageDesc = data.url
          } else {
            state.fileList = []
            message.error(retInfo)
          }
        } else {
          message.info('文件未上传！')
        }
      },
      handleSearch(input, option) {
        return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      handleAddressChange(item, val, countryRegionType) {
        if (countryRegionType === 1) {
          item.geoInfo.region = null
          item.geoInfo.city = null
          item.citys = []
        } else if (countryRegionType === 2) {
          item.geoInfo.city = null
        }
        state.getAddressData(item, countryRegionType, val)
      },
      getAddressData: async (
        item,
        countryRegionType,
        parentCountryRegionCode
      ) => {
        const { success, data } = await abtest_select_post({
          countryRegionType,
          parentCountryRegionCode
        })
        if (success) {
          const list = (data.list || []).filter(item => item.countryRegionCode)
          countryRegionType === 0 && (state.countrys = list)
          countryRegionType === 1 && (item.provinces = list)
          countryRegionType === 2 && (item.citys = data.list || [])
        }
      },
      changeNumber: () => {
        let total = 0
        for (let i = 1; i < state.variants.length; i++)
          total = Number(total) + Number(state.variants[i].weight)
        state.variants[0].weight = 100 - Number(total)
      },
      hasDuplicateNames: arr => {
        return arr.some((item, index) => {
          const duplicates = arr.filter(
            (innerItem, innerIndex) =>
              innerItem.name === item.name && index !== innerIndex
          )
          return duplicates.length > 0
        })
      },
      save: async () => {
        const obj = {
          ...state.baseInfo,
          ...{ fuzzyMatch: state.baseInfo.fuzzyMatch ? 0 : 1 }
        }
        const regexName = /^[\u4e00-\u9fa5a-zA-Z0-9_\-'"‘’“”]+$/
        // obj.startTime = state.time[0]
        // obj.endTime = state.time[1]
        state.urlRule = false
        state.nameRule = false
        state.weightRule = false

        if (!obj.name) {
          message.error('请输入实验名称', 3)
          return
        } else if (!regexName.test(obj.name)) {
          message.error(
            '支持输入中文、英文、数字、下划线、中划线、引号、双引号，不支持特殊字符',
            3
          )
          return
        }

        if (!obj.runTime) {
          message.error('请输入运行周期', 3)
          return
        }
        if (!state.baseInfo.layerId) {
          message.error('请选择实验层', 3)
          return
        }
        if (state.baseInfo.layerId && !state.baseInfo.weight) {
          message.error('实验层占用比例不能为空', 3)
          return
        }
        if (state.baseInfo.type - 0 === 1 && !state.baseInfo.url) {
          message.error('实验url不能为空', 3)
          return
        }
        if (
          state.baseInfo.type - 0 === 2 &&
          !state.baseInfo.collectionIds.length
        ) {
          message.error('collectionId不能为空', 3)
          return
        }
        if (state.audiences.type === 3 && !state.audiences.userGroupId) {
          message.error('指定用户群不能为空', 3)
          return
        }
        if (state.audiences.type === 2 && !state.audiences.groups.length) {
          message.error('受众条件不能为空', 3)
          return
        }
        const audienceEmpty = state.audiences.groups.some(item => {
          return item.audienceDetails.find(n => {
            return n.type === 0
              ? !n.geoInfo?.country
              : n.content === '' || n.content === null
          })
        })
        if (state.audiences.type === 2 && audienceEmpty) {
          message.error('受众条件不能为空', 3)
          return
        }

        for (let k = 0; k < state.variants.length; k++) {
          if (state.variants[k].name === '') {
            state.nameRule = true
          }
          if (state.variants[k].weight === '') {
            state.weightRule = true
          }
        }
        if (state.urlRule === true) {
          message.error('请输入网页定位', 3)
          return
        }
        if (state.nameRule === true) {
          message.error('请输入分组名称', 3)
          return
        }
        if (state.weightRule === true) {
          message.error('请输入流量比例', 3)
          return
        }
        const copyVariant = JSON.parse(JSON.stringify(state.variants))
        if (state.hasDuplicateNames(copyVariant)) {
          message.error('实验变体名称不能重复')
          return
        }
        let flowPercent = 0
        for (let i = 0; i < copyVariant.length; i++) {
          flowPercent += copyVariant[i].weight < 0 ? 0 : copyVariant[i].weight
        }
        if (flowPercent > 100) {
          message.error('流量占比总和不能超过100%')
          return
        }
        // 校验自定义参数
        const noValueList = []
        const duplicateNameValues = []
        const nameValidate = []
        // const valueValidate = []
        let regex = /^(?!\d)[a-zA-Z0-9_]+$/
        for (let i = 0; i < copyVariant.length; i++) {
          const duplicateNames = {}
          let item = copyVariant[i]
          let name = item.name
          if (item.customParam.length > 0) {
            let newCustomParam = []
            JSON.parse(JSON.stringify(item.customParam)).forEach(i => {
              if (i.name && i.value) {
                newCustomParam.push(i)
              }
              if (i.name && i.value === '') {
                noValueList.push({
                  name: `【${name}】${i.name}`
                })
              }
            })
            newCustomParam.forEach(obj => {
              if (!duplicateNames[obj.name]) {
                duplicateNames[obj.name] = true
              } else {
                duplicateNameValues.push(
                  `【${name}】中，参数名称 ${obj.name} 重复`
                )
              }
            })
            newCustomParam.forEach(obj => {
              if (!regex.test(obj.name)) {
                nameValidate.push(
                  `【${name}】的参数名称：${obj.name}不符合条件`
                )
              }
            })
            // newCustomParam.forEach(obj => {
            //   if (!regex.test(obj.value)) {
            //     valueValidate.push(
            //       `【${name}】的参数值：${obj.value}不符合条件`
            //     )
            //   }
            // })
            item.customParam = newCustomParam
          }
        }
        let allValidateList = [...nameValidate]
        if (allValidateList.length > 0) {
          let hDom = allValidateList.map(i => h('p', i))
          Modal.error({
            title: () =>
              '您的参数包含无效字符。参数键仅可包含下划线、字母、数字，且不以数字开头',
            content: () => h('div', {}, hDom)
          })
          return
        }
        if (duplicateNameValues.length > 0) {
          let hDom = duplicateNameValues.map(i => h('p', i))
          Modal.error({
            title: () => '参数名称重复',
            content: () => h('div', {}, hDom)
          })
          return
        }
        if (noValueList.length > 0) {
          let hDom = noValueList.map(i => h('p', `${i.name}的参数值为空`))
          Modal.error({
            title: () => '参数值不能为空',
            content: () => h('div', {}, hDom)
          })
          // message.error({
          //   content: `请填写自定义参数${noValueList
          //     .map(i => i.name)
          //     .join('、')}的参数值`,
          //   duration: 3
          // })
          return
        }
        copyVariant.forEach(i => {
          i.customParam = i.customParam
            ? JSON.stringify(i.customParam)
            : JSON.stringify([])
        })
        for (let i = 0; i < copyVariant.length; i++)
          copyVariant[i].weight = copyVariant[i].weight / 100
        const audienceList = JSON.parse(JSON.stringify(state.audiences))
        audienceList.groups.forEach(item => {
          item.audienceDetails.forEach(n => {
            delete n.provinces
            delete n.citys
          })
        })

        const { success, retInfo } = await abtest_new_save_post({
          audiences:
            state.audiences.type === 1
              ? { groups: [], type: 1, logic: '', id: null, userGroupId: null }
              : audienceList,
          baseInfo: obj,
          // urlPosition: state.urlPosition,
          variants: copyVariant,
          abMetricConfigDTOS: state.abMetricConfigDTOS
        })
        if (success === true) {
          message.success(
            '保存成功（请确认此AB 实验是否涉及订单等中台服务，如涉及请对接响应人员）',
            3
          )

          const { brandId, siteId, channelId, terminalId } = state.baseInfo
          router.push({
            path: '/ABtestV3',
            query: {
              type: state.typeSave,
              staus: state.statusSave,
              id: state.idSave,
              name: state.nameSave
            },
            state: {
              params: {
                brandId: brandId - 0,
                siteId: siteId - 0,
                channelId: channelId - 0,
                terminalId: terminalId - 0
              }
            }
          })
        } else {
          message.error(retInfo)
        }
      },
      cancel: () => {
        const { brandId, siteId, channelId, terminalId } = state.baseInfo
        router.push({
          path: '/ABtestV3',
          state: {
            params: {
              brandId: brandId - 0,
              siteId: siteId - 0,
              channelId: channelId - 0,
              terminalId: terminalId - 0
            }
          }
        })
      }
    })
    const ListPush = list => {
      list.push({
        type: 1,
        content: ''
      })
    }

    const showDialog = () => {
      if (!state.newParams.scriptContent && !state.newCss.cssContent) {
        message.error('请配置实验脚本或css样式')
        return
      }
      state.modalVisible = true
      state.sourceObj = {
        cssContent: state.newCss.cssContent,
        scriptContent: state.newParams.scriptContent
      }
    }
    const ListPush1 = list => {
      let customParam = state.variants[0].customParam.map(i => {
        return {
          name: i.name,
          value: ''
        }
      })
      list.push({
        id: '',
        name: '',
        weight: '',
        description: '',
        scriptContent: '',
        cssContent: '',
        customParam: customParam
      })
    }
    const ListPush2 = list => {
      list.push({
        type: 0,
        ruleType: 1,
        userContent: '1',
        geoInfo: { country: null, region: null, city: null }
      })
    }
    const ListPush3 = list => {
      list.push({ detailList: [{ type: 1, content: '' }] })
    }

    const ListRemove = (_, index, list) => {
      list.splice(index, 1)
    }
    // 这里做受众用户切换的逻辑
    const onChange = (e, n) => {
      if (e === 0) n.geoInfo = { country: null, region: null, city: null }
      else n.content = null
    }

    const getQuery = async baseId => {
      if (baseId) {
        const { data } = await abtest_new_query_get({ baseId })
        state.time = data.baseInfo.time //[data.baseInfo.startTime, data.baseInfo.endTime]
        for (let i = 0; i < data.variants.length; i++) {
          data.variants[i].weight = data.variants[i].weight * 100
          data.variants[i].deviceIds = data.variants[i].deviceIds || []
          data.variants[i].customParam = data.variants[i].customParam
            ? JSON.parse(data.variants[i].customParam)
            : []
        }
        state.isApp = data.baseInfo.terminalId === 2
        state.oldRunTime = data.baseInfo.runTime
        data.baseInfo.type = data.baseInfo.type.toString()
        state.disableStatus = data.baseInfo.status
        state.baseInfo = data.baseInfo
        state.baseInfo.fuzzyMatch = !data.baseInfo.fuzzyMatch
        // state.urlPosition = data.urlPosition
        state.audiences = data.audiences
        // state.abMetricConfigDTOS = data.abMetricConfigDTOS.map(i => {
        //   return {
        //     ...i,
        //     id: i.abtestMetricOptionId
        //   }
        // })
        state.variants = data.variants
        if (state.isCopy) {
          state.baseInfo.id = null
          state.baseInfo.startTime = null
          state.baseInfo.endTime = null
          state.baseInfo.status = 1
          state.disableStatus = 1
          state.variants.forEach(item => {
            item.id = null
          })
        }
        state.audiences.groups.forEach(groupItem => {
          groupItem.audienceDetails?.forEach(item => {
            if (item.type === REGION) {
              if (item.geoInfo?.country) {
                state.getAddressData(item, 1, item.geoInfo?.country)
              }
              if (item.geoInfo?.region) {
                state.getAddressData(item, 2, item.geoInfo?.region)
              }
            }
          })
        })
      } else {
        state.variants[0].weight = 100
        const route = useRoute()
        state.baseInfo.branId = route.query.branId
        state.baseInfo.channelId = route.query.channelId
        state.baseInfo.siteId = route.query.siteId
        state.baseInfo.terminalId = route.query.terminalId
        state.isApp = route.query.terminalId === '2'
      }
      state.isView = route.query.isView === '1'
      let userGroupIdList = []
      if (state.audiences.userGroupId) {
        userGroupIdList = [state.audiences.userGroupId]
      }
      state.userGroupInfo.userGroupIdList = userGroupIdList
      state.getUserGroupList()
      // state.getMatricList()
      state.getLayorList()
    }
    let scriptVisible = ref(false)
    let cssVisible = ref(false)
    const showScript = (item, index) => {
      state.newParams = { ...item }
      state.index = index
      scriptVisible.value = true
    }
    const showCss = (item, index) => {
      state.newCss = { ...item }
      state.cssIndex = index
      cssVisible.value = true
    }
    const okScript = () => {
      scriptVisible.value = false
      state.variants[state.index].scriptContent = state.newParams.scriptContent
    }
    const okCss = () => {
      cssVisible.value = false
      state.variants[state.cssIndex].cssContent = state.newCss.cssContent
    }
    async function handleUiniqId() {
      const { brandId, siteId, channelId, terminalId } = state.baseInfo
      const siteInfo = await getUiniqId({
        brandId,
        siteId,
        channelId,
        terminalId,
        pageNum: 1,
        pageSize: 20
      })
      state.uniqueId = siteInfo.data.list[0]?.uniqueId
    }

    onMounted(() => {
      state.isReport = route.query.isReport
      if (state.isReport === '1') {
        state.activeTabKey = '2'
      }
      getQuery(route.query.id)
      state.getDeviceList()
      state.getGeoData()
      state.baseInfo.type = Number(route.query.testType)
      state.isCopy = route.query.isCopy === '1'
      state.baseInfo.branId = route.query.branId
      state.baseInfo.channelId = route.query.channelId
      state.baseInfo.siteId = route.query.siteId
      state.baseInfo.terminalId = route.query.terminalId
      handleUiniqId()
      state.idSave = route.query.id1
      state.statusSave = route.query.status
      state.typeSave = route.query.type
      state.nameSave = route.query.name
      state.getAddressData({}, 0, null)
    })

    watch(
      () => state.activeTabKey,
      newVal => {
        if (newVal === '2') {
          state.getReportBasicInfo()
          state.showEcharts = true
          myChart = null
        }
      }
    )
    const typeList = computed(() => {
      return state.isApp
        ? userRule
        : userRule.slice(0, 1).concat(userRule.slice(2))
    })
    watch(
      () => [
        state.baseInfo.startTime,
        state.disableStatus,
        state.reportBasicInfo.startTime
      ],
      () => {
        state.reportBasicInfo.startTime &&
          (state.reportDate = [
            dayjs(state.reportBasicInfo.startTime, 'YYYY-MM-DD'),
            dayjs(state.reportBasicInfo.endTime, 'YYYY-MM-DD').subtract(
              state.disableStatus === 2 ? 0 : 1,
              'day'
            )
          ])
      }
    )
    watch(state.baseInfo.collectionIds, () => {
      state.collectionIdDatas = []
      state.fetching = false
    })
    watch(
      () => [state.reportDate, state.metricsId],
      ([date, metricsId]) => {
        if (date?.length && metricsId) {
          state.getMetricsInfo()
        }
      }
    )
    onUnmounted(() => {
      state.showEcharts = false
    })
    const now = dayjs()
    const isTimeDisabled = computed(() => {
      if ([1, 2].includes(state.disableStatus)) {
        return true
      }
      return false
    })
    const disabledRangeDate = current => {
      return current && current < now.startOf('day')
    }
    provide('initState', state)
    return {
      CONDITION_RULES,
      activeKey,
      ListRemove,
      selectRule,
      userLabels,
      userActions,
      typeList,
      userProperties,
      userTypeRule,
      onChange,
      showScript,
      scriptVisible,
      showCss,
      cssVisible,
      okScript,
      okCss,
      ListPush,
      ListPush1,
      ListPush2,
      ListPush3,
      isTimeDisabled,
      disabledRangeDate,
      ...toRefs(state),
      showDialog
    }
  }
})
</script>
<style>
.ant-select-selection-overflow {
  max-height: 200px;
  overflow-y: auto;
}
</style>
<style scoped lang="scss">
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}

::v-deep {
  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    background: #eee !important;
  }
  .ant-form-item {
    margin-bottom: 12px;
  }
  .avatar-uploader > .ant-upload {
    width: 76px;
    height: 76px;
  }

  .cds > .ant-collapse-content {
    width: 100%;
    height: 100%;
    border-left: 1px solid #eee;
    background: -webkit-linear-gradient(top, transparent 15px, #eee 0),
      -webkit-linear-gradient(left, transparent 15px, #eee 0);
    background-size: 16px 16px;
  }
}

.border-transparent {
  border: 1px solid transparent;
}

.border-transparent {
  border: 1px solid transparent;
}

.border-transparent:hover,
.border-transparent:focus {
  border-color: #40a9ff;
}

.btn {
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.preview {
  color: green;
  position: absolute;
  top: 1px;
  right: 10px;
}
.report-title {
  background: #efefef;
  line-height: 40px;
  padding-left: 20px;
}
.report-content {
  padding: 20px;
  margin-bottom: 10px;
}
.flex {
  display: flex;
  align-items: center;
}
</style>
